import { OrderActionParams } from './../../../models/common/order-status.model';
import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TradingService } from './../../../services/common/trading-service.service';
import { MutualFundTradingService } from './../../../services/mutualfund/mutualfund-trading-service.service';
import { EquityTradingService } from './../../../services/equity/equity-trading-service.service';
import { OptionTradingService } from '../../../services/option/option-trading-service.service';
import { TRADING_PLATFORM } from './../../../utils/trading-constants';
import { Account, TradeType, UserType, TransactionType, TradingOrderBase } from './../../../models/common/trading-common.model';
import { TradingEntitlements } from './../../../models/common/trading-entitlements';
import { LogService, PershingTranslationService } from '@pershing/pershing-core';
import { GetUserType, backToDotCOM, isAveragePriceAccount } from './../../../utils/trading-common';
import moment_ from 'moment';

const moment = moment_;

@Component({
  selector: 'cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.css']
})
export class CancelOrderComponent implements OnInit {
  @Input() cancelOrderParams: OrderActionParams;
  @Input() account: Account;
  @Input() ordQty: any;
  @Input() complexPopup: any;

  tradingEntitlements: TradingEntitlements;
  showErrorMessage: boolean;
  showEntitlementErrorForComplexEdit: boolean = false;
  isLoading: boolean = true;
  submissionInProgress: boolean = false;
  isOrderCancelSuccess: boolean;
  hideSubmit: boolean = false;
  errorTxt: string;
  cancelOrderTimeStr: string = '';
  platform: string = TRADING_PLATFORM.PROFESSIONAL;
  order: any = {};

  hideClose: boolean = false;   // For cancel-order popup in .COM or .NET, should hide dialog Close button

  isEquityOrder: boolean;
  isMutualFundOrder: boolean;
  isOptionsOrder: boolean;
  isComplexOptionOrder: boolean;
  dialogTitle: string;

  mutualFundEnabled: boolean;
  isPlan529Account: boolean;
  isBdUser: boolean = false;
  isRiaUser: boolean = false;
  isDualUser: boolean = false;
  isAPA: boolean = false;
  nonDollarTrade: boolean = false;
  isOmniBus : boolean =false;
  ordRcvDate: string;
  ordRcvTime: string;
  activeTheme:string;
  accountName: string = '';
  cancelOrderTransationStyle: string = 'tr-OrderTitle_Buy';

  isAnnuityOrder: boolean;
  isFromMyClientView: boolean;
  constructor(
    private tradingService: TradingService,
    private equityTradingService: EquityTradingService,
    private mutualFundTradingService: MutualFundTradingService,
    private optionTradingService: OptionTradingService,
    private logService: LogService,
    private translationService: PershingTranslationService,
    @Optional() public dialogRef: MatDialogRef<CancelOrderComponent>,
    @Optional() @Inject('AppSettings') appSettings: any,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any
  ) {
    if (appSettings) {
      this.platform = appSettings.platform;
    }
  }

  ngOnInit() {
    this.activeTheme = this.tradingService.getActiveThemeFromCurrentContainer();
    if (this.dialogData) {  // For IWE Portal, it opens as dialog component - data passed in as dialog data
      this.account = this.dialogData.account;
      this.tradingEntitlements = this.dialogData.tradingEntitlements;
      this.cancelOrderParams = this.dialogData.params;

      this.mutualFundEnabled = this.tradingEntitlements.isMutualFundEnabled;
      this.isPlan529Account = !!this.account && !!this.account.acctCatgCd && (this.account.acctCatgCd.indexOf('529') > -1);
      if ( this.cancelOrderParams ) {
        this.getOrderDetailsFromCancelOrderParams();
      }
    }

    // Check for an option strategy code to determine if this is a complex option order.
    // BUT, ignore strategy code "SI" as this indicates a Single order, and per mainframe
    // team we must use the regular order details and order cancel APIs for single orders,
    // even with the strategy code present.
    this.handleComplexOptionOrderandisOmniBus();
    this.isAPA = isAveragePriceAccount(this.account.acctNum);
  }

  private handleComplexOptionOrderandisOmniBus():void
  {
    if ( !this.tradingEntitlements.isEntitledToComplexOption ) {
      this.isComplexOptionOrder = false;
    } else if (this.cancelOrderParams?.complexOptionCd === 'Y' || this.cancelOrderParams?.complexOptionStrategyCd === 'SI') {
      this.isComplexOptionOrder = true;
    } else {
      this.isComplexOptionOrder = false;
    }

    if (this.account?.acctClassificationCd ?.toUpperCase() === 'OM') {
      this.isOmniBus=true;
    }
    else{
      this.isOmniBus=false;
    }
  }

  ngOnChanges() {
    if (this.cancelOrderParams) { // For integration with .com, data passed in as @Input() data
      this.hideClose = true;
      this.tradingEntitlements = this.tradingService.tradingEntitlements;
      this.mutualFundEnabled = this.tradingEntitlements.isMutualFundEnabled;
      
      this.getOrderDetailsFromCancelOrderParams();
    }
  }

  private getOrderDetailsFromCancelOrderParams(): void {
    if ( this.cancelOrderParams.ordProdCodeText.trim() === 'Option' && this.cancelOrderParams.complexOptionCd === 'Y' ) {
      if (!this.tradingEntitlements.isEntitledToComplexOption || 
          (this.cancelOrderParams.complexOptionStrategyCd === 'RT' && !this.tradingEntitlements.isEntitledToComplexRatioOption)) {
        this.showEntitlementErrorForComplexEdit = true;
        this.isLoading = false;
        return;
      }
      // Multi-leg Options Order; orders with "SI" (SINGLE) strategy code have to get their details through the regular getOrderDetails() call.
      this.optionTradingService.getMultiLegOrderDetails(this.cancelOrderParams.platform, this.cancelOrderParams.accountNo, this.cancelOrderParams.ordDtlKey,
      this.cancelOrderParams.subRequestTypeCode, this.cancelOrderParams.ordProdCodeText, this.cancelOrderParams.origSysRefNo).subscribe(
        data => this.fetchOrderSuccess(data),
        err => this.fetchOrderError(err)
      );
    } else if (
      this.cancelOrderParams.ordProdCodeText.trim() === 'Equity' || this.cancelOrderParams.ordProdCodeText.trim() === 'Option'
      || this.cancelOrderParams.ordProdCodeText.trim() === 'Annuity'
    ) {
      if ( this.ordQty != null ) {
        this.ordQty = this.ordQty.trim();
      }
      this.tradingService.getOrderDetails(this.cancelOrderParams.platform, this.cancelOrderParams.accountNo, this.cancelOrderParams.ordDtlKey,
      this.cancelOrderParams.subRequestTypeCode, this.cancelOrderParams.ordProdCodeText).subscribe(
        data => this.fetchOrderSuccess(data),
        err => this.fetchOrderError(err)
      );
    } else if (this.cancelOrderParams.ordProdCodeText.trim() === 'Mutual Fund') {
      this.mutualFundTradingService.getOrderDetails(this.cancelOrderParams.platform, this.cancelOrderParams.accountNo, this.cancelOrderParams.ordDtlKey,
      this.cancelOrderParams.subRequestTypeCode).subscribe(
        data => this.fetchOrderSuccess(data),
        err => this.fetchOrderError(err)
      );
    }
  }

  fetchOrderSuccess(resp) {
    this.isLoading = false;
    if (resp.errorCode === 0 && resp.response && (resp.response.eqtOptTradeReturnCode === 'SUCCESS' || resp.response.mutualFundTradeReturnCode === 'SUCCESS')) {
        this.showErrorMessage = false;
        this.order = resp.response;
        const transactionType = this.order.transactionType;
        // ordProdCodeText possible value in Json API: "Equity"|"Mutual Fund"|"Option"|"Fixed Income"
        this.handleEquityOrder(resp,transactionType);
        this.handleMutualfundOrder(resp,transactionType);
        this.handleOptionOrder(resp,transactionType);

        if (resp.response.ordProdCodeText && resp.response.ordProdCodeText.trim() === 'Annuity') {
          this.isAnnuityOrder = true;
          this.order.tradeType = TradeType.ANNUITY;
          this.dialogTitle = 'labels.annuityCancelOrderReview';
          this.cancelOrderTransationStyle = 'tr-OrderTitle';
        }
        this.handleOrdRcvDateTime();
        this.handleAccountName();

        if ( this.tradingEntitlements.isProfessionalUser ) {
          let currUserType: UserType = GetUserType(this.account, this.tradingEntitlements);
          this.isRiaUser = UserType.RIA === currUserType;
          this.isBdUser = UserType.BD === currUserType;
          this.isDualUser = UserType.DUAL === currUserType;
        }
        this.nonDollarTrade = !!(this.order.settlementCcy || '').trim() && this.order.quote && this.order.quote.symId.indexOf(':') !== -1;
    } else {
      this.showErrorMessage = true;
      this.logService.error('fetchOrder resp error - ', resp);
    }
  }

  private handleAccountName():void
  {
    let acctNum = this.account.acctNum;
    let acctShortName = this.account.acctShortName;
    let regTypeDescription = this.account.regTypeDescription;

    if (!acctShortName) {
      this.accountName = acctNum;
      if (this.tradingEntitlements.isRetailUser && regTypeDescription) {
        this.accountName = regTypeDescription + ' - ' + acctNum;
    }
    } else {
      this.accountName = acctShortName;
      if (regTypeDescription) {
          this.accountName += '\'s ' + regTypeDescription;
      }
      this.accountName += ' - ' + acctNum;
    }
  }

  private handleOrdRcvDateTime():void
  {
    if (this.order.secPerOrdRcvDate) {
        this.ordRcvDate = moment(this.order.secPerOrdRcvDate, 'YYYYMMDD').format('L');
    } else {
        this.ordRcvDate = '';
    }

    if (this.order.secPerOrdRcvTime) {
        this.ordRcvTime = moment(this.order.secPerOrdRcvTime, 'hhmmss').format('LT');
    } else {
        this.ordRcvTime = '';
    }
  }

  private handleEquityOrder(resp,transactionType) :void
  {
    if (resp.response.ordProdCodeText && resp.response.ordProdCodeText.trim() === 'Equity') {
      this.isEquityOrder = true;
      this.order.tradeType = TradeType.EQUITY;
      this.dialogTitle = 'labels.equityCancelOrderReview';
      if (transactionType === TransactionType.BUY || transactionType === TransactionType.BUY_TO_COVER) {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Buy';
      } else {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Sell';
      }
    }

  }

  private handleMutualfundOrder(resp,transactionType) :void
  {
    if (resp.response.ordProdCodeText && resp.response.ordProdCodeText.trim() === 'Mutual Fund') {
      this.isMutualFundOrder = true;
      this.order.tradeType = TradeType.MUTUAL_FUND;
      if (this.isPlan529Account) {
        this.dialogTitle = 'labels.plan529FundCancelOrderReview';
      } else {
        this.dialogTitle = 'labels.mutualFundCancelOrderReview';
      }
      if (transactionType === TransactionType.BUY) {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Buy';
      } else if (transactionType === TransactionType.REDEEM || transactionType === TransactionType.REDEEM_ALL) {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Sell';
      } else {
        this.cancelOrderTransationStyle = 'tr-OrderTitle';
      }
    }

  }

  private handleOptionOrder(resp,transactionType): void
  {
    if (resp.response.ordProdCodeText && resp.response.ordProdCodeText.trim() === 'Option') {
      this.isOptionsOrder = true;
      this.order.tradeType = TradeType.OPTION;

      if ( this.cancelOrderParams.complexOptionStrategyCd === 'SI' ) {
        // Need to manually set the order's strategy field to 'SINGLE'
        this.order.strategy = 'SINGLE';

        // Also need to put the symbol, transaction type, account type, and order quantity into an option leg
        this.order.optionLegList = [];
        this.order.optionLegList[0] = {
          transactionType: this.order.transactionType,
          quote: this.order.quote,
          accountType: this.order.accountType,
          ordQty: this.order.strQty,
          nmeTxt3: this.order.nmeTxt3,
          netxOpnClsInd: this.order.netxOpnClsInd
        };

      }
      this.dialogTitle = 'labels.optionCancelOrderReview';
      if (transactionType === TransactionType.BUY) {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Buy';
      } else {
        this.cancelOrderTransationStyle = 'tr-OrderTitle_Sell';
      }
    }
  }

  fetchOrderError(err) {
    this.showErrorMessage = true;
    this.isLoading = false;
    this.logService.error('fetchOrderError error - ', err);
  }

  cancelOrder() {
    this.isFromMyClientView = false;
    if (this.tradingEntitlements.isMyClientViewUser) {
      this.isFromMyClientView = true;
      return;
    }

    let params: OrderActionParams = this.cancelOrderParams;
    if (params.platform && params.accountNo && params.ordDtlKey && params.subRequestTypeCode) {
      this.submissionInProgress = true;
      this.isOrderCancelSuccess = false;
      this.errorTxt = '';

      if (this.isEquityOrder) {
        this.equityTradingService.cancelEquityOrder(params.platform, params.accountNo, params.ordDtlKey, params.subRequestTypeCode).subscribe(
          data => this.cancelOrderSuccess(data),
          err => this.cancelOrderError(err)
        );
      }

      if (this.isMutualFundOrder) {
        this.mutualFundTradingService.cancelMutualFundOrder(params.platform, params.accountNo, params.ordDtlKey, params.subRequestTypeCode).subscribe(
          data => this.cancelOrderSuccess(data),
          err => this.cancelOrderError(err)
        );
      }

      if (this.isOptionsOrder) {
        this.handleCancelOptionOrder(params);
      }

      if (this.isAnnuityOrder) {
        this.tradingService.cancelAnnuityOrder(params.platform, params.accountNo, params.ordDtlKey, params.subRequestTypeCode).subscribe(
          data => this.cancelOrderSuccess(data),
          err => this.cancelOrderError(err)
        );
      }
    }
  }

  private handleCancelOptionOrder(params):void
  {
    if (this.isComplexOptionOrder && this.cancelOrderParams.complexOptionStrategyCd !== 'SI') {
      this.optionTradingService.cancelMultiLegOptionOrder(params.platform, params.accountNo, params.ordDtlKey, params.subRequestTypeCode, params.origSysRefNo).subscribe(
        data => this.cancelOrderSuccess(data),
        err => this.cancelOrderError(err)
      );
    } else {
      this.optionTradingService.cancelOptionOrder(params.platform, params.accountNo, params.ordDtlKey, params.subRequestTypeCode).subscribe(
        data => this.cancelOrderSuccess(data),
        err => this.cancelOrderError(err)
      );
    }
  }

  cancelOrderSuccess(resp) {
    this.logService.log('cancelOrderSuccess - ', resp);
    this.submissionInProgress = false;

    if (resp.errorCode === 0) {
      let orderResponse = resp.response;
      if (((this.isEquityOrder || this.isOptionsOrder) && orderResponse.eqtOptTradeReturnCode === 'SUCCESS')
            || (this.isMutualFundOrder && orderResponse.mutualFundTradeReturnCode === 'SUCCESS')
            || (this.isAnnuityOrder && orderResponse.annFiIntlTradeReturnCode === 'SUCCESS')) {
            this.handleCancelOrderIforderResponseisSuccess(resp,orderResponse);
      } else {
          this.handleCancelOrderIforderResponseisnotSuccess(orderResponse);
      }
    }
    this.hideSubmit = true;
  }

  private handleCancelOrderIforderResponseisnotSuccess(orderResponse):void
  {
    this.isOrderCancelSuccess = false;
    this.errorTxt = (orderResponse.errorTxt || '').trim() ;
    if (!this.errorTxt) {
      this.translationService.get('errors.SYSTEM_ERROR_MESSAGE').subscribe(txt => this.errorTxt = txt);
    }
    if (this.isEquityOrder) {
      this.dialogTitle = 'labels.equityCancelOrderViolations';
    }
    if (this.isOptionsOrder) {
      this.dialogTitle = 'labels.optionCancelOrderViolations';
    }
    if (this.isMutualFundOrder) {
      if (this.isPlan529Account) {
        this.dialogTitle = 'labels.plan529FundCancelOrderViolations';
      } else {
        this.dialogTitle = 'labels.mutualFundCancelOrderViolations';
      }
    }
    if (this.isAnnuityOrder) {
       this.dialogTitle = 'labels.annuityCancelOrderViolations';
    }
  }

  private handleCancelOrderIforderResponseisSuccess(resp,orderResponse):void
  {
    this.isOrderCancelSuccess = true;
    if ((orderResponse.ordDatetimeStr || '').trim()) {
      // this.cancelOrderTimeStr = moment(orderResponse.ordDtTime).utcOffset(0).format('MM/DD/YYYY hh:mm A') + ' ET';
      let dateStr = orderResponse.ordDatetimeStr.substr(0, 10);
      let timeStr = orderResponse.ordDatetimeStr.substr(11, 8).replace(/\./g, ':');
      this.cancelOrderTimeStr = moment(dateStr + ' ' + timeStr).format('MM/DD/YYYY hh:mm A') + ' ET';
    } else if (Number.isInteger(orderResponse.ordDtTime)) {
      this.cancelOrderTimeStr = moment(orderResponse.ordDtTime).format('MM/DD/YYYY hh:mm A') + ' ET';
    }
    this.tradingService.newOrderNotification({} as TradingOrderBase);
    // Notify Cancel Order action performed with status submitted.
    // This will allow the parent screen to perform any successive actions like refreshing the grid.
    this.tradingService.notifyActionPerformed({ action: 'cancel', status: 'submitted' });
    if (this.isEquityOrder) {
      this.dialogTitle = 'labels.equityCancelOrderConfirm';
    }
    if (this.isOptionsOrder) {
      this.dialogTitle = 'labels.optionCancelOrderConfirm';

      if ( this.complexPopup ) {
        console.log('Submit button has been clicked, dispatching custom event for .NET');
        // When user has clicked the submit button, it is hidden whether the cancel
        // was successful or errored out, and there is no re-try offered. Instruct
        // the .NET app's Order Status page via event that the order was submitted.
        document.dispatchEvent(new CustomEvent('portal.gotoview',{
          detail: {
            gotoPage: 'nxp-order-status',
            gotoParams: {
              isUserFromLegacyOTS: true,
              action: 'ordersubmitted'
            }
          }
        }));
      }
    }
    if (this.isMutualFundOrder) {
      if (this.isPlan529Account) {
        this.dialogTitle = 'labels.plan529FundCancelOrderConfirm';
      } else {
        this.dialogTitle = 'labels.mutualFundCancelOrderConfirm';
      }
    }
    if (this.isAnnuityOrder) {
      this.dialogTitle = 'labels.annuityCancelOrderConfirm';
      this.cancelOrderTimeStr = resp.response.formattedOrderPlacedDateTime;
    }
  }

  hideReviewTxt() {
    let toggleOn: boolean;
    if (this.isEquityOrder || this.mutualFundEnabled) {
      if (this.isOrderCancelSuccess) {
        toggleOn = false;
      } else {
        toggleOn = true;
      }
    }
    return toggleOn;
  }

  cancelOrderError(err) {
    this.logService.error('cancelOrderError error - ', err);
    this.submissionInProgress = false;
    this.isOrderCancelSuccess = false;
    this.translationService.get('errors.SYSTEM_ERROR_MESSAGE').subscribe(txt => this.errorTxt = txt);
    this.hideSubmit = true;
    if (this.isEquityOrder) {
      this.dialogTitle = 'labels.equityCancelOrderViolations';
    }
    if (this.isOptionsOrder) {
      this.dialogTitle = 'labels.optionCancelOrderViolations';
    }
    if (this.isMutualFundOrder) {
      if (this.isPlan529Account) {
        this.dialogTitle = 'labels.plan529FundCancelOrderViolations';
      } else {
        this.dialogTitle = 'labels.mutualFundCancelOrderViolations';
      }
    }
    if (this.isAnnuityOrder) {
      this.dialogTitle = 'labels.annuityCancelOrderViolations';
    }
  }

  back() {
    let sourceVal: string = '';
    if (this.cancelOrderParams) {
      sourceVal = this.cancelOrderParams.contextType || '';
    }
    const action = {
      useraction: this.isOrderCancelSuccess ? 'yes' : 'no',
      gotoPage: sourceVal + '-order-status',
      account: this.account.acctNum,
      source: sourceVal
    };
    backToDotCOM(action);
  }

  closePopup() {
    console.log('Close button has been clicked, dispatching custom event for .NET');
    // When user clicks the close button, regardless of whether the order was
    // submitted for cancel or not, instruct the .NET app's Order Status page via
    // event to close this popup window. If we previously sent the event to
    // notify of order submission, the .NET app will also refresh the Order Status
    // page.
    document.dispatchEvent(new CustomEvent('portal.gotoview',{
      detail: {
        gotoPage: 'nxp-order-status',
        gotoParams: {
          isUserFromLegacyOTS: true,
          action: 'close'
        }
      }
    }));
  }

  public printOrder() {

    let style = document.createElement('style');
    style.media = 'print';
    style.id = 'pershing_trading_order_entry_print_style';
    let styles = 'body { visibility: hidden } cancel-order { visibility: visible; position: absolute; left: 0px; top: 0px; z-index: -1; }' +
                 '.mat-dialog-actions { border-top: none !important } .wrapper.container-fluid { display: none }';
    style.appendChild(document.createTextNode(styles));

    document.body.appendChild(style);

    // window.print();
    document.execCommand('print', false, null);

    let element = document.getElementById('pershing_trading_order_entry_print_style');
    element.parentNode.removeChild(element);
  }
}
